import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function usePaymentPixAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function generatePaymentPixFromRemote(orderIds, tip) {
    const url = `/vbeta2/payments/pix`;

    return axios({
      url,
      method: 'post',
      data: {
        order_ids: orderIds,
        tip: tip ?? 0,
      },
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function cancelPaymentPixFromRemote(id) {
    const url = `/vbeta2/payments/pix/${id}/cancel`;

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
      validateStatus: (status) => [200, 404, 422].includes(status),
    });
  }

  function refreshPaymentPixStatusFromRemote(id) {
    const url = `/vbeta2/payments/pix/${id}/refresh`;

    return axios({
      url,
      method: 'post',
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    generatePaymentPixFromRemote,
    cancelPaymentPixFromRemote,
    refreshPaymentPixStatusFromRemote,
  };
}

export { usePaymentPixAPI };
